export default "__VITE_ASSET__W42jLMNP__"